<template id="Dashboard">
    <v-app>
        <v-container fluid class="bg-grey-lighten-4 px-10">
            <!-- Welcome Header -->
            <v-row dense>
                <v-col cols="12">
                    <v-card variant="flat" style="background: linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)" class="pa-2 rounded-lg" elevation="2">
                        <v-row class="justify-space-between ml-2">
                            <v-col cols="12" md="8">
                                <h1 class="text-h5 font-weight-black text-primary mb-1">
                                    {{ greeting }}, {{ userName }}!
                                </h1>
                                <div class="text-subtitle-2 text-medium-emphasis">
                                    {{ currentDate }} · Here's what's happening with your modules today.
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" class="d-flex flex-column align-end">
                                <v-chip size="small" color="purple-lighten-4" rounded="sm" class="font-weight-bold" variant="flat">
                                  <span class="mr-2" >Total Modules: </span><span>{{ getNavbarItems?.length }}</span>
                                </v-chip>
                                <v-spacer></v-spacer>
                                <v-btn v-if="getNavbarItems?.length" to="/dashboard/master" color="primary" variant="flat" size="small"
                                       prepend-icon="mdi-view-dashboard" class="mt-2 font-weight-bold">
                                    Master Dashboard
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col v-for="(item, index) in getNavbarItems" :key="index"
                       cols="12" sm="6" md="4" lg="3">
                    <v-card variant="elevated" class="rounded-lg h-100"
                            :elevation="2" hover
                            @click="goTo('/module/' + item.prefix)">
                        <v-card-item>
                            <v-row justify="center" align="center">
                                <v-col cols="12" class="d-flex flex-column flex-nowrap align-center text-center">
                                    <v-avatar size="40" rounded-xl class="mb-3"
                                              :style="{ background: getGradient(index) }" dark>
                                        <v-icon size="20">{{ item.icon }}</v-icon>
                                    </v-avatar>

                                    <h3 class="text-subtitle-2 font-weight-bold flex-nowrap text-primary mb-1">
                                        {{ item.name }}
                                    </h3>

                                </v-col>
                            </v-row>
                        </v-card-item>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import {useStore} from 'vuex';

export default {
        components: {
            breadCrumbs,
        },
        name: 'Dashboard',
        data: () => ({
            loading: false,
            form_loading: false,
            errorMessages: '',
            search: "",
            gradients: [
                'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
                'linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)',
                'linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)',
                'linear-gradient(135deg, #f5576c 0%, #ff6a88 100%)',
                'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
                'linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)',
            ],
            statColors: [
                '#1976d2', '#388e3c', '#fbc02d', '#d32f2f'
            ]
        }),

        watch: {
        },
        created(){
        },
        computed:{
            getSchema() {
                return this.$store.getters.getMenuList;
            },
            getNavbarItems(){
                return this.$store.getters.getNavbarItems
            },
            greeting() {
                const hour = new Date().getHours();
                if (hour < 12) return 'Good Morning';
                if (hour < 17) return 'Good Afternoon';
                return 'Good Evening';
            },
            userName() {
                const user = JSON.parse(localStorage.getItem('user'));
                return user ? (user.full_name || user.username || 'User') : 'User';
            },
            currentDate() {
                return new Date().toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            },
            shortDate() {
                return new Date().toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                });
            },
        },
        methods: {
            clear(){

            },
            goTo(val) {
                    this.$router.push({ path: val }).catch(err => {});
            },
            getGradient(index) {
                return this.gradients[index % this.gradients.length];
            },
            getDataFromApi(){
                this.loading = true;
                this.$store.dispatch('getMenuList')
                .then(data => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    toast.error(error.response.data.message);
                })
                .then(always => {
                    this.loading = false;
                })
            },

        },

        mounted() {
            // this.getDataFromApi();
          }
    }
</script>


<!--<template id="Dashboard">-->
<!--  <v-app>-->
<!--    <v-container fluid>-->
<!--      <v-row>-->
<!--        <v-col lg="3" md="3" cols="12" v-for="(item, index) in getNavbarItems" :key="index">-->
<!--          <v-card color="primary" class="pa-3" @click="goTo('/module/' + item.prefix)">-->
<!--            <v-card-title class="pa-0 ma-0">-->
<!--              <v-btn density="comfortable" size="small"   variant="tonal" color="blue-grey-lighten-4" :icon="item.icon"></v-btn>-->
<!--              <div class="mt-2"><span class="text-subtitle-1 font-weight-medium">{{item.name}}</span></div>-->
<!--            </v-card-title>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </v-container>-->
<!--  </v-app>-->
<!--</template>-->

<!--<script>-->

<!--import breadCrumbs from '@/components/utils/breadCrumbs.vue';-->
<!--import {useStore} from 'vuex';-->

<!--export default {-->
<!--  components: {-->
<!--    breadCrumbs,-->
<!--  },-->
<!--  name: 'Dashboard',-->
<!--  data: () => ({-->
<!--    loading:false,-->
<!--    form_loading: false,-->
<!--    errorMessages:'',-->
<!--    search: "",-->
<!--    options: {-->
<!--      chart: {-->
<!--        id: 'vuechart-example'-->
<!--      },-->
<!--      xaxis: {-->
<!--        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]-->
<!--      }-->
<!--    },-->
<!--    series: [{-->
<!--      name: 'series-1',-->
<!--      data: [30, 40, 45, 50, 49, 60, 70, 91]-->
<!--    }]-->
<!--  }),-->

<!--  watch: {-->
<!--  },-->
<!--  created(){-->
<!--    // this.form_loading = true;-->
<!--    //     this.$store.dispatch('getDashboardList').then(data => {-->
<!--    //         this.form_loading = false;-->
<!--    //    });-->
<!--  },-->
<!--  computed:{-->
<!--    getSchema() {-->
<!--      return this.$store.getters.getMenuList;-->
<!--    },-->
<!--    getNavbarItems(){-->
<!--      return this.$store.getters.getNavbarItems-->
<!--    }-->
<!--  },-->
<!--  methods: {-->
<!--    clear(){-->

<!--    },-->
<!--    goTo(val) {-->
<!--      this.$router.push({ path: val }).catch(err => {});-->
<!--    },-->
<!--    getDataFromApi(){-->
<!--      this.loading = true;-->
<!--      this.$store.dispatch('getMenuList')-->
<!--          .then(data => {-->
<!--            this.loading = false;-->
<!--          })-->
<!--          .catch(error => {-->
<!--            this.loading = false;-->
<!--            toast.error(error.response.data.message);-->
<!--          })-->
<!--          .then(always => {-->
<!--            this.loading = false;-->
<!--          })-->
<!--    },-->

<!--  },-->

<!--  mounted() {-->
<!--    // this.getDataFromApi();-->
<!--  }-->
<!--}-->
<!--</script>-->